import AppTopbar from "../Components/AppTopbar";
import { useTranslation } from "react-i18next";
import dbservice from "../Utility/DbConnection/dbservice.js";
import { TransformIntSQLDate } from "../Utility/Utility";
import { Panel } from "primereact/panel";

import { Toast } from "primereact/toast";

import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Image } from "primereact/image";
import MyChartComponent from "../Components/Chart/MyChartComponent";
import SearchPanelComponent from "../Components/Panels/SearchPanelComponent";
import dbManagerInterface from "../Utility/DbConnection/DBManagerInterface.js";
import SPCDialog from "../Components/Dialogs/SPCDialog.js";
import { Button } from "primereact/button";
const route = "Automata/Running/";
const idValueName = "ID";

function RunningPage() {
  const type = "running";

  const toast = useRef(null);
  const { t } = useTranslation();
  const [showGraph, setShowGraph] = useState(false);
  const [isDataPresent, setIsDataPresent] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [topNumber, setTopNumber] = useState(null);
  const [sampleTime, setSampleTime] = useState(60);
  const [idValue, setIdValue] = useState(null);
  const [measures, setMeasures] = useState([]);
  const [measuresMetadata, setMeasuresMetadata] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [loading, setLoading] = useState(false);

  const [chartData, setChartData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [spcVisible, setSpcVisible] = useState(false);

  useEffect(() => {}, []); // Dependency array is empty, so it runs only on mount

  const onSearchClick = () => {
    setLoading(true);
    setIsDataPresent(false);

    const startDateSQL = TransformIntSQLDate(startDate);
    const endDateSQL = TransformIntSQLDate(endDate);

    if (startDate > endDate) {
      console.log("Start Date is greater than End Date");
      toast.current.show({
        severity: "error",
        summary: t("error"),
        detail: t("error1"),
        life: 3000,
      });
    }

    const machineMeasures = {};
    let machinesToSend = selectedMachine.map((machine) => machine.Machine);
    if (measures) {
      // I will send only the machines included by the measures
      const machinesToSend = new Set();

      Object.keys(measures).forEach((key) => {
        if (!key.includes("-")) return; // Skip if it's just the machine name

        const [machineName, measure] = key.split("-", 2); // Split into machine name and measure name

        if (!machineMeasures[machineName]) {
          machineMeasures[machineName] = [];
        }
        machineMeasures[machineName].push(measure);
        machinesToSend.add(machineName); // Use a Set to avoid duplicates
      });
      // //i filter also metadata to pass to chart
      // const filteredMetadata = measuresMetadata.filter(
      //     metadata => measures.includes(metadata.Name)
      // );
      // console.log("filteredMetadata", filteredMetadata)
    }

    let bladeDict = {};
    if (idValue !== null && idValue !== "") {
      bladeDict = { [idValueName]: [idValue] }; // Use computed property name
    }

    const body = {
      Machines: machinesToSend,
      DateStart: startDateSQL,
      DateEnd: endDateSQL,
      Top: topNumber,
      SampleTime: sampleTime,
      Measures: machineMeasures,
      WhereMeasures: bladeDict,
    };
    dbManagerInterface.SendPostRequest(
      route + "GetMeasures",
      JSON.stringify(body),
      (resData) => {
        if (!resData.success || resData.data?.length === 0) {
          toast.current.show({
            severity: "warn",
            summary: t("warning"),
            detail: t("warning1"),
            life: 3000,
          });
          setIsDataPresent(false);
          setLoading(false);
        } else {
          // Update chartData with the filtered data
          setChartData(resData.data);
          const otherColumns = [];
          const tsColumn = []; // Array to store the TS column
          const columnNames = new Set(); // Track column names to avoid duplicates
          resData.data.forEach((item) => {
            Object.keys(item).forEach((key) => {
              if (!columnNames.has(key)) {
                // Check if column name already exists
                columnNames.add(key);
                const columnComponent = (
                  <Column
                    key={key}
                    field={key}
                    header={key.charAt(0).toUpperCase() + key.slice(1)}
                    sortable
                  />
                );

                if (key === "TS") {
                  tsColumn.push(columnComponent); // Add TS column to its own array
                } else {
                  otherColumns.push(columnComponent); // Add other columns
                }
              }
            });
          });
          // Combine TS column with other columns, ensuring TS is first
          const combinedColumns = [...tsColumn, ...otherColumns];
          setColumns(combinedColumns);
          setIsDataPresent(true);
          setLoading(false);
        }
      },
      (error) => {
        console.error("error", error);
        setLoading(false);
      },
      toast.current
    );
  };
  const tableHeader = () => {
    return (
      <div className="flex justify-between">
        <Button
          type="button"
          icon="pi pi-chart-line"
          label={t("spc")}
          outlined
          style={{ width: "150px", marginLeft: "20px" }}
          onClick={() => setSpcVisible(true)}
        />
      </div>
    );
  };

  return (
    <div>
      <AppTopbar title={t("running")} menuCode={4} />
      <Toast ref={toast} />
      <SearchPanelComponent
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        topNumber={topNumber}
        setTopNumber={setTopNumber}
        sampleTime={sampleTime}
        setSampleTime={setSampleTime}
        selectedMachine={selectedMachine}
        setSelectedMachine={setSelectedMachine}
        selectedMeasures={measures}
        type={type}
        setSelectedMeasures={setMeasures}
        setMeasuresMetadata={setMeasuresMetadata}
        measuresMetadata={measuresMetadata}
        showGraph={showGraph}
        setShowGraph={setShowGraph}
        onSearchClick={onSearchClick}
        idValue={idValue}
        setIdValue={setIdValue}
        tableData={chartData}
      />
      <Panel>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              display: !showGraph && isDataPresent ? "block" : "none",
              width: "100%",
              overflowX: "auto",
            }}
          >
            <DataTable
              value={chartData}
              header={tableHeader}
              stripedRows
              showGridlines
              paginator
              rowsPerPageOptions={[5, 10, 25, 50]}
              rows={10}
            >
              {columns}
            </DataTable>
          </div>

          <div
            style={{
              display: showGraph && isDataPresent ? "block" : "none",
              width: "100%",
            }}
          >
            <MyChartComponent
              chartData={chartData}
              measuresMetadata={measuresMetadata}
              visible={showGraph && isDataPresent}
            />
          </div>
          <div
            style={{
              display: loading ? "block" : "none",
            }}
          >
            <Image
              src={"/pms/loading.gif"}
              alt={"loading"}
              style={{ display: loading ? "block" : "none" }}
            ></Image>
          </div>

          <div
            style={{
              display: !isDataPresent && !loading ? "block" : "none",
              height: "50%",
              margin: "5%",
            }}
          >
            <h1>{t("noData")}</h1>
            <Image
              src={"/pms/no_data.gif"}
              alt={"no_data"}
              style={{ width: "50%" }}
            ></Image>
          </div>
        </div>
        <SPCDialog
          visible={spcVisible}
          onHide={() => setSpcVisible(false)}
          chartData={chartData}
          measuresMetadata={measuresMetadata}
          storeType={"Running"}
        ></SPCDialog>
      </Panel>
    </div>
  );
}

export default RunningPage;
